<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Pilih Jenis Pembayaran</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="jenisPembayaran"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="jenis pembayaran"
          label="name"
          v-model="formData.jenis_id"
          placeholder="Pilih Jenis Pembayaran"
        />
        <span class="text-danger text-sm">{{ errors.first("jenis pembayaran") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Pilih Metode Pembayaran</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="metodePembayaran"
          :reduce="(v) => v.id"
          class="w-full"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="metode pembayaran"
          label="name"
          v-model="formData.metode_id"
          placeholder="Pilih Metode Pembayaran"
        />
        <span class="text-danger text-sm">{{ errors.first("metode pembayaran") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Jumlah Pembayaran</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          @keypress="onlyNumber"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="jumlah pembayaran"
          class="w-full sidebar-input"
          v-model="formData.jumlah_bayar"
          placeholder="Isi Dengan Jumlah Pembayaran"
        />
        <span class="text-danger text-sm">{{ errors.first("jumlah pembayaran") }}</span>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addData"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
    jenisPembayaran: { type: Array, default: [] },
    metodePembayaran: { type: Array, default: [] },
  },
  data() {
    return {
      formData: {
        user_id: null,
        jenis_id: null,
        metode_id: null,
        jumlah_bayar: null,
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null ? "Edit Transaksi" : "Tambah Transaksi";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.user_id !== null &&
        this.formData.jenis_id !== null &&
        this.formData.metode_id !== null &&
        this.formData.jumlah_bayar !== null
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData.user_id = this.passData.user.id;
        this.formData.jenis_id = this.passData.jenis_pembayaran.id;
        this.formData.metode_id = this.passData.metode_pembayaran.id;
        this.formData.jumlah_bayar = this.passData.jumlah_bayar;
      } else {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.formData.user_id = null;
      this.formData.jenis_id = null;
      this.formData.metode_id = null;
      this.formData.jumlah_bayar = null;
    },
    profile() {
      return JSON.parse(localStorage.getItem("profileAccess")).data;
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addData() {
      this.$vs.loading({
        color: "primary",
      });
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      this.formData.user_id = this.profile.id;
      this.$store
        .dispatch("transaksi/cudTransaksi", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.loading.close();
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Transaksi Sukses!"
                : "Tambah Transaksi Sukses!",
            text:
              this.passData !== null
                ? `Transaksi ${v.metode_pembayaran.name} Berhasil diedit`
                : `Transaksi ${v.metode_pembayaran.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });

          this.closeWithLoad(true);
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.resetForm();
        });
    },
  },
};
</script>
